import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Grid from "@material-ui/core/Grid";
import Skeleton from "react-loading-skeleton";
import withCustomStyles from "./ProductLoadingPart.style";

// Skeleton cells matching ProductsListPart's grid (same columns and gutters).
@inject(["uiStore"])
@observer
class ProductLoadingPart extends Component {
  render() {
    const { classes, uiStore, count } = this.props;
    return Array.from({ length: count || 12 }, (_, i) => (
      <Grid
        key={i}
        item
        xs={uiStore.extraSmall() ? 12 : 6}
        sm={4}
        md={3}
        lg={2}
        className={classes.tileItem}
        aria-hidden="true"
      >
        <div className={classes.card}>
          <Skeleton className={classes.tile} />
          <Skeleton height={20} width="45%" />
          <Skeleton height={18} width="90%" />
          <Skeleton height={16} width="35%" />
        </div>
      </Grid>
    ));
  }
}

export default withCustomStyles(ProductLoadingPart);
